import { render } from "./Icd10Codes.vue?vue&type=template&id=70a5e75e"
import script from "./Icd10Codes.vue?vue&type=script&lang=js"
export * from "./Icd10Codes.vue?vue&type=script&lang=js"

import "./Icd10Codes.vue?vue&type=style&index=0&id=70a5e75e&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/allIcd10Codes/Icd10Codes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70a5e75e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70a5e75e', __exports__)) {
    console.log('reload')
    api.reload('70a5e75e', __exports__)
  }
  
  module.hot.accept("./Icd10Codes.vue?vue&type=template&id=70a5e75e", () => {
    console.log('re-render')
    api.rerender('70a5e75e', render)
  })

}


export default __exports__